import MatchedMap from 'utilities/src/matchedMap';

import { InputStateEnum } from '../../../shared/utils/state';
import type { InputThemeProps } from '../../../shared/utils/themes';

/**
 * InputText Classes
 */

const inputTextClasses = 'border-none focus:outline-none';

/**
 * InputText Wrapper Classes
 */

const inputTextWrapperClasses = 'flex flex-col flex-wrap gap-1';

const inputTextWrapperStateClasses = new MatchedMap([
  [InputStateEnum.Default, ''],
  [InputStateEnum.Success, ''],
  [InputStateEnum.Error, ''],
  [InputStateEnum.Disabled, 'pointer-events-none opacity-40'],
]);

/**
 * Common Theme
 */

const inputTextCommonTheme = ({ inputState }: Pick<InputThemeProps, 'inputState'>) => ({
  inputTextCommonClasses: inputTextClasses,
  inputTextWrapperCommonClasses: inputTextWrapperStateClasses
    .get(InputStateEnum[inputState])
    .concat(' ', inputTextWrapperClasses),
});

export default inputTextCommonTheme;
